import {
    ServiceEditOptionState,
    SchedulingPolicyState,
    AvailabilityState,
    AvailabilityType,
} from '../store/schema/ServiceEditOptionState';
import EnhancedLocation from 'owa-service/lib/contract/EnhancedLocation';
import SchedulingPolicy from 'owa-service/lib/contract/SchedulingPolicy';

export default function initializeServiceEditState(
    defaultSchedulingPolicy?: SchedulingPolicy
): ServiceEditOptionState {
    let defaultDurationMinutes: number = 30;
    let defaultMinLeadTime: number = defaultSchedulingPolicy?.LeadTimeInMinutes || 60;
    let defaultMaxLeadTime: number = defaultSchedulingPolicy?.EndOfBookingWindowInDays || 90;

    return {
        id: '',
        name: '',
        description: '',
        charm: 0,
        categoryNames: [],
        duration: defaultDurationMinutes,
        location: {
            DisplayName: '',
            Annotation: '',
        } as EnhancedLocation,
        isOnlineMeeting: false,
        schedulingPolicy: {
            leadTimeForBookingsInMinutes: defaultMinLeadTime,
            leadTimeForCancellationsInMinutes: defaultMinLeadTime,
            leadTimeInMinutes: defaultMinLeadTime,
            endOfBookingWindowInDays: defaultMaxLeadTime,
        } as SchedulingPolicyState,
        availability: {
            availabilityType: AvailabilityType.DefaultSetup,
            isDateRestricted: false,
            startDate: null,
            endDate: null,
            customHours: [],
            isDirty: false,
        } as AvailabilityState,
        hasError: false,
        showErrorMessage: false,
    };
}
